<template>
  <div class="comp-xl-member-tips">
    <template v-if="memberList?.length">
      <div v-for="item in memberList?.filter((v, i) => v && i + 1 <= props.showNumber)" :key="item.id" class="member-item">
        <xl-avatar :key="item.id" :avatar="{ id: item.id, name: item.userName, url: item.avatarOrigin }" :size="32" />
      </div>
      <!-- <div v-if="memberList?.length > props.showNumber" class="member-more">
        <span class="member-more-text">+{{ memberList?.length - props.showNumber }}</span>
      </div> -->
      <!-- <div v-if="memberList?.length > props.showNumber" class="member-more">
        <icon-more :size="22" />
      </div> -->
    </template>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { userService } from '@/api/';
// import { getToken } from '@/utils/auth';
import { Message } from '@arco-design/web-vue';
console.log('1-开始创建组件-setup');
const data = reactive({});
const props = defineProps({
  showNumber: {
    type: [Number, String],
    default: 5
  }
});
// const paramCode = getToken(); //系统初始化时需要的token
const memberList = ref([]); //要展示的人员列表集合
console.log(26, data, props);
// 获取角色列表
const getAdminUserList = async () => {
  try {
    const res = await userService.getAdminUserList();
    memberList.value = res.result?.adminUserList;
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || '获取数据失败');
  }
};
onMounted(async () => {
  await getAdminUserList();
});
</script>
<style scoped lang="less">
@import './xl-member-tips.less';
</style>
